import FaceLandmark from "./FaceLandmark";
import "./styles.css";

export default function App() {
  return (
    <>
      <FaceLandmark />
    </>
  );
}
